module.exports = __webpack_public_path__ + "static/media/servicebackground2.23a4b998.png";